import React, { useRef, useState, useEffect } from 'react'
import { downloadFile } from '@fuse/utils/fileUtils';
import { AgGridReact } from 'ag-grid-react';
import '../../../../../styles/ag-custom.css';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import { Tooltip } from '@material-ui/core'
import { Icon } from '@mui/material'
import { withRouter } from 'react-router-dom';
import axios from '@fuse/utils/axios';
import FilePreviewModal from 'helper/filePreview';

function FilesTab({ serviceRequestId, files }) {
  const tableHeaders = ["file_name", "upload_date"];
  const [windowHeight, setWindowHeight] = useState(window.innerHeight - 430);
  const gridRef = useRef();
  const [serviceRequestFiles, setServiceRequestFiles] = useState([])

  const [filePreviewLink, setFilePreviewLink] = useState('')
  const [openFilePreviewLink, setOpenFilePreviewLink] = useState(false)
  const [fileName, setfileName] = useState('')

  const onGridReady = params => {
    gridRef.current = params;
    // Following line to make the currently visible columns fit the screen  
    params.api.sizeColumnsToFit();

    // Following line dynamic set height to row on content
    params.api.resetRowHeights();
  };


  function setHeaderName(header) {
    const headers = header
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
      .join(" ");
    console.log('headers', headers);
    return headers
  }

  function fetchFiles() {
    if (!serviceRequestId) return
    axios.get(`/service/request/get-files/${serviceRequestId}`).then((res) => {
      const { files } = res.data.data;
      setServiceRequestFiles(files)
    }).catch((err) => {
      console.log(err);
    })
  }

useEffect(() => {
    // fetchFiles()
    setServiceRequestFiles(files)
  }, [files?.length])

  function handleClose() {
    setOpenFilePreviewLink(false)
    setFilePreviewLink('')
    setfileName('')
  }

  return (
    <>
      {serviceRequestFiles?.length === 0 &&
        <div className='no_data_holder'>
          <img src='assets/images/nodata.svg' alt='icon' />
          <p className='bold_txt'>It's all empty here!</p>
          <p className='normal_txt'>No data to show yet</p>
        </div>
      }

      {serviceRequestFiles?.length > 0 &&
        <div
          className="ag-theme-alpine"
          style={{
            width: "100%",
            height: windowHeight + 105,
            fontSize: '12px'
          }}
        >
          <AgGridReact
            ref={gridRef}
                    theme="legacy"
            rowData={serviceRequestFiles}
            animateRows
            onGridReady={onGridReady}
            rowHeight={38}
						headerHeight={44}
            paginationPageSize={10}
                            paginationPageSizeSelector={[10, 20, 50, 100]}
            pagination
            defaultColDef={{
              resizable: true
            }}
            columnDefs={[{
              lockPosition: true,
              rowSelection: "single",
              width: 120,
              minWidth: 120,
              maxWidth: 120,
              suppressSizeToFit: true,
              headerName: "Actions",
							suppressMenu: true,          
							suppressHeaderMenuButton: true,
							sortable: false,
              pinned: "right",
              className: "action_field",
              lockPinned: true,
              cellRenderer: ({ data }) => {
                if (data) {
                  return (
                    <>
                      <Tooltip id="view" title="View" placement="top">
                        <Icon
                          onClick={() => {
                            setOpenFilePreviewLink(true)
                            setFilePreviewLink(data.file_link)
                            setfileName(data?.file_name)
                          }}
                          style={{
                            color: "#1d2939",
                            paddingBottom: "5px",
                            paddingRight: "30px",
                            fontSize: "15px",
                            cursor: "pointer",
                          }}
                        >
                          visibility
                        </Icon>
                      </Tooltip>

                      <Icon
                        onClick={() => downloadFile(data.file_link, data.file_name)}
                        style={{ cursor: 'pointer', color: '#1D2939', fontSize: '18px', padding: '4px 4px' }}
                        title="Download"
                      >
                        download
                      </Icon>

                    </>
                  );
                }
                return <></>;
              },
            },
              ...tableHeaders.map(header => {
                return {
                  field: header,
                  key: header,
                  flex: 1,
                  minWidth: 200,
                  headerName: setHeaderName(header),
                  sortable: true,
                  headerComponent: (props) => (CustomFilter(props, header, gridRef)),
                  filter: "agTextColumnFilter",
                }
              })
            ]}
          />

          {
            openFilePreviewLink && <FilePreviewModal
              open={openFilePreviewLink}
              close={handleClose}
              filePreviewLink={filePreviewLink}
              fileName={fileName}
            />
          }
        </div>
      }
    </>
  )
}

export default withRouter(FilesTab)
